import script from "./AdServices.vue?vue&type=script&setup=true&lang=js"
export * from "./AdServices.vue?vue&type=script&setup=true&lang=js"

import "./AdServices.vue?vue&type=style&index=0&id=62d4ed28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d4ed28"]])

export default __exports__